var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8992 9.34307C67.5188 9.34307 72.0347 10.713 75.8757 13.2795C79.7168 15.8461 82.7105 19.4941 84.4784 23.7621C86.2462 28.0302 86.7088 32.7266 85.8075 37.2576C84.9063 41.7885 82.6817 45.9505 79.4152 49.2171C76.1486 52.4837 71.9868 54.7083 67.456 55.6096C62.9251 56.5109 58.2288 56.0483 53.9608 54.2804C49.6929 52.5125 46.045 49.5187 43.4785 45.6776C40.9119 41.8364 39.5421 37.3204 39.5421 32.7007C39.5421 26.5059 42.0029 20.5648 46.3832 16.1844C50.7635 11.804 56.7045 9.34307 62.8992 9.34307ZM62.8992 0C56.4318 0 50.1095 1.91787 44.7321 5.51107C39.3546 9.10427 35.1633 14.2114 32.6883 20.1867C30.2134 26.162 29.5658 32.737 30.8275 39.0803C32.0893 45.4237 35.2036 51.2504 39.7768 55.8237C44.35 60.3969 50.1766 63.5114 56.5197 64.7731C62.8629 66.0349 69.4378 65.3873 75.4129 62.9123C81.3881 60.4372 86.4951 56.2459 90.0883 50.8683C93.6814 45.4907 95.5992 39.1683 95.5992 32.7007C95.5992 24.028 92.154 15.7104 86.0216 9.57782C79.8891 3.44525 71.5718 0 62.8992 0Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 128H115.2V104.642C115.2 101.575 114.372 98.5379 112.764 95.704C111.156 92.8701 108.799 90.2952 105.827 88.1262C102.856 85.9573 99.3283 84.2367 95.4459 83.0629C91.5635 81.8891 87.4023 81.2849 83.2 81.2849H44.8C36.3131 81.2849 28.1737 83.7458 22.1726 88.1262C16.1714 92.5066 12.8 98.4477 12.8 104.642V128H0V104.642C0 95.9698 4.71999 87.6522 13.1216 81.5197C21.5232 75.3871 32.9183 71.9419 44.8 71.9419H83.2C95.0817 71.9419 106.477 75.3871 114.878 81.5197C123.28 87.6522 128 95.9698 128 104.642V128Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.3934b4d9fe9af971b847193e92fac1ff.svg";
export { ForwardRef as ReactComponent };